// Time formatting utilities for consistent IST timezone handling

/**
 * Format date and time in IST timezone
 * @param {string|Date} dateString - Date string or Date object
 * @param {Object} options - Formatting options
 * @returns {string} Formatted date string
 */
export const formatIndianDateTime = (dateString, options = {}) => {
    if (!dateString) return 'N/A';

    try {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return 'N/A';
        }

        const defaultOptions = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'Asia/Kolkata',
            hour12: true
        };

        const finalOptions = { ...defaultOptions, ...options };

        return date.toLocaleString('en-IN', finalOptions);
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'N/A';
    }
};

/**
 * Format date only in IST timezone
 * @param {string|Date} dateString - Date string or Date object
 * @returns {string} Formatted date string
 */
export const formatIndianDate = (dateString) => {
    if (!dateString) return 'N/A';

    try {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return 'N/A';
        }

        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'Asia/Kolkata'
        };

        return date.toLocaleDateString('en-IN', options);
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'N/A';
    }
};

/**
 * Format time only in IST timezone
 * @param {string|Date} dateString - Date string or Date object
 * @returns {string} Formatted time string
 */
export const formatIndianTime = (dateString) => {
    if (!dateString) return 'N/A';

    try {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return 'N/A';
        }

        const options = {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'Asia/Kolkata',
            hour12: true
        };

        return date.toLocaleTimeString('en-IN', options);
    } catch (error) {
        console.error('Error formatting time:', error);
        return 'N/A';
    }
};

/**
 * Get current time in IST
 * @returns {string} Current time in IST
 */
export const getCurrentISTTime = () => {
    const now = new Date();
    const options = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'Asia/Kolkata',
        hour12: true
    };
    return now.toLocaleTimeString('en-IN', options);
};

/**
 * Get current date and time in IST
 * @returns {string} Current date and time in IST
 */
export const getCurrentISTDateTime = () => {
    const now = new Date();
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'Asia/Kolkata',
        hour12: true
    };
    return now.toLocaleString('en-IN', options);
}; 